module.exports = __webpack_public_path__ + "static/media/Call.eb256518.svg";